import { ACTION } from './zone_vrf_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  filteredCount: 0,
  isLoading: false,
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return { ...state, isLoading: true, errorMessage: null };
    case `${ACTION.LIST}_FULFILLED`:
      return { ...state, ...list_reducer(state, action), isLoading: false };
    case `${ACTION.LIST}_REJECTED`:
      return { ...state, isLoading: false, errorMessage: action.payload };

    case `${ACTION.CREATE}_PENDING`:
      return { ...state, isCreating: true, errorMessage: null };
    case `${ACTION.CREATE}_FULFILLED`:
      return { ...state, ...add_reducer(state, action), isCreating: false };
    case `${ACTION.CREATE}_REJECTED`:
      return { ...state, isCreating: false, errorMessage: action.payload };

    case `${ACTION.EDIT}_PENDING`:
      return { ...state, isEditing: true, errorMessage: null };
    case `${ACTION.EDIT}_FULFILLED`:
      return { ...state, ...update_reducer(state, action), isEditing: false };
    case `${ACTION.EDIT}_REJECTED`:
      return { ...state, isEditing: false, errorMessage: action.payload };

    case `${ACTION.DELETE}_PENDING`:
      return { ...state, isDeleting: true, errorMessage: null };
    case `${ACTION.DELETE}_FULFILLED`:
      return { ...state, ...delete_reducer(state, action), isDeleting: false };
    case `${ACTION.DELETE}_REJECTED`:
      return { ...state, isDeleting: false, errorMessage: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_vrf_reducer.js